import { BarChart } from '@mantine/charts';
import { formatAbbreviatedCurrency, formatMoney } from 'src/common/currency';
import type { BreakdownKey, RevenueStep } from 'src/secret-menu/billing/hooks/useRevenue';
import SectionCard from '../overview/SectionCard';

const SERIES = [
  { name: 'advisers', label: 'Adviser firms', color: 'blue.5' },
  { name: 'pipeline', label: 'Pipeline', color: 'green.5' },
  { name: 'buildFee', label: 'Strategic partner build fee', color: 'orange.5' },
  { name: 'licenseFee', label: 'Strategic partner license fee', color: 'violet.4' },
];

export default function RevenueStepsChart({ steps }: { steps: readonly RevenueStep[] }) {
  // The chart works in pounds; the figures arrive in pence.
  const pounds = (step: RevenueStep, ...keys: BreakdownKey[]) =>
    keys.reduce((total, key) => total + step.arrPence[key], 0) / 100;
  const data = steps.map(step => ({
    label: step.label,
    advisers: pounds(step, 'ADVISER_PER_UNIT', 'ADVISER_FIXED'),
    pipeline: pounds(step, 'PIPELINE'),
    buildFee: pounds(step, 'MONUMENT_BUILD'),
    licenseFee: pounds(step, 'MONUMENT_LICENSE'),
  }));

  return (
    <SectionCard title="Revenue Projections">
      <BarChart
        h={320}
        data={data}
        dataKey="label"
        type="stacked"
        series={SERIES}
        withLegend
        legendProps={{ verticalAlign: 'bottom' }}
        yAxisProps={{ tickFormatter: value => formatAbbreviatedCurrency(value, 'GBP'), width: 70 }}
        valueFormatter={value => formatMoney(value, 'GBP')}
        barProps={{ radius: 0 }}
        maxBarWidth={140}
      />
    </SectionCard>
  );
}
